import React from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Avatar, Card, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { contactAtom, contactInstrumentAtom } from 'pages/Contacts/atoms/contactAtoms'
import { formatString, roundNumberWithCommas } from 'utils/utils'
import { sendWalletAtom } from '../atoms/atoms'

export const SendDetailsCard = () => {
  const { t } = useTranslation()
  const contact = useAtomValue(contactAtom)
  const contactInstrument = useAtomValue(contactInstrumentAtom)
  const sendWallet = useAtomValue(sendWalletAtom)

  return (
    <Card variant="static" emphasis full>
      <DataListItem
        id="send-details-card"
        layout="vertical"
        title={t('wallets.send.sendingFromWallet')}
        BodyAvatar={
          <Avatar
            size="small"
            type="currency"
            name={sendWallet?.currency ? sendWallet?.currency?.code?.toLowerCase() : ''}
          />
        }
        body={`${sendWallet?.description} | ${formatString(
          t('balanceWithCurrency'),
          sendWallet?.currency?.fiat
            ? roundNumberWithCommas(sendWallet?.balance)
            : roundNumberWithCommas(sendWallet?.balance, 6),
          sendWallet?.currency?.code
        )}`}
      />

      <DataListItem
        id="send-details-card"
        layout="vertical"
        title={t('wallets.send.sendingTo')}
        BodyAvatar={<Avatar size="small" type="entity" name={contact?.name ?? ''} />}
        body={`${contact?.name ?? ''} | ${ellipseMiddleText(contactInstrument?.address ?? '', 6, 6)}`}
      />
    </Card>
  )
}
